import React from 'react'
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles'
import InputAdornment from '@material-ui/core/InputAdornment'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import { Word } from '../../../containers';
import { puzzleTurnItems } from '../../../constants';
import { WID } from '../../../constants/Language';

const styles = theme => ({
  root: {
    display: 'flex',
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    alignItems: 'center',
  },
  margin: {
    margin: theme.spacing.unit,
  },
  textField: {
    flexBasis: 150,
  },
  inputAdornment: {
    width: 50,
  },
})

class TurnSelectMenu extends React.Component {
  render() {
    const { classes, selectedTurn, handleChange } = this.props

    return selectedTurn !== undefined ? (
      <TextField
        select
        value={selectedTurn}
        onChange={handleChange}
        className={classNames(classes.margin, classes.textField)}
        InputProps={{
          startAdornment: <InputAdornment position="start" className={classes.inputAdornment}><Word wid={WID.RENJU_BOARD_CARD.TURN_SELECT_MENU.TURN}/></InputAdornment>,
        }}
      >
        {puzzleTurnItems.map((items, index) => (
          <MenuItem key={index} value={index}>
            <Word wid={items.wid}/>
          </MenuItem>
        ))}
      </TextField>
    ) : null
  }
}

export default withStyles(styles)(TurnSelectMenu)



// WEBPACK FOOTER //
// ./src/components/Common/RenjuBoardCard/TurnSelectMenu.js